var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2197 3.21967C13.5126 2.92678 13.9874 2.92678 14.2803 3.21967L22.2803 11.2197C22.5732 11.5126 22.5732 11.9874 22.2803 12.2803L14.2803 20.2803C13.9874 20.5732 13.5126 20.5732 13.2197 20.2803C12.9268 19.9874 12.9268 19.5126 13.2197 19.2197L20.6893 11.75L13.2197 4.28033C12.9268 3.98744 12.9268 3.51256 13.2197 3.21967Z",
    fill: "#000928"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.21967 3.21967C1.51256 2.92678 1.98744 2.92678 2.28033 3.21967L10.2803 11.2197C10.5732 11.5126 10.5732 11.9874 10.2803 12.2803L2.28033 20.2803C1.98744 20.5732 1.51256 20.5732 1.21967 20.2803C0.926777 19.9874 0.926777 19.5126 1.21967 19.2197L8.68934 11.75L1.21967 4.28033C0.926777 3.98744 0.926777 3.51256 1.21967 3.21967Z",
    fill: "#000928"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrows);
export default __webpack_public_path__ + "static/media/arrows.5fab38d695152c7080bf4d7d2ba80c20.svg";
export { ForwardRef as ReactComponent };